import { readStoredTheme, resolveTheme, storeTheme, themeSwitchState, toggledTheme } from "./theme-core.js";

const root = document.documentElement;
const toggle = document.querySelector("[data-theme-toggle]");
const deviceTheme = window.matchMedia("(prefers-color-scheme: dark)");

function readPreference() {
  try {
    return readStoredTheme(window.localStorage);
  } catch {
    return null;
  }
}

function savePreference(theme) {
  try {
    storeTheme(window.localStorage, theme);
  } catch {
    // The switch still works for this document when storage is unavailable.
  }
}

function applyTheme(theme) {
  const state = themeSwitchState(theme);
  root.dataset.theme = theme;
  root.style.colorScheme = theme;
  if (!toggle) return;
  toggle.setAttribute("aria-checked", state.ariaChecked);
  toggle.setAttribute("title", state.title);
}

toggle?.addEventListener("click", () => {
  const nextTheme = toggledTheme(root.dataset.theme);
  savePreference(nextTheme);
  applyTheme(nextTheme);
});

const handleDeviceThemeChange = event => {
  if (!readPreference()) applyTheme(resolveTheme(null, event.matches));
};

if (typeof deviceTheme.addEventListener === "function") deviceTheme.addEventListener("change", handleDeviceThemeChange);
else deviceTheme.addListener?.(handleDeviceThemeChange);

applyTheme(resolveTheme(readPreference(), deviceTheme.matches));
